<span class="{{balloonContainerClass}}">
    <span class="{{balloonBodyClass}}">
        {{content}}
    </span>
</span>
